<template>
    <div>
        <DCard padding>
            <DRow>
                <DCol>
                    <DTable
                        :items="contracts.items"
                        :fields="fields"
                    >
                        <template #customer_number="{item}">
                            <td v-if="item.customer_number">
                                <Link
                                    :href="customerUrl(item.customer_number)"
                                >
                                    {{ item.customer_number }}
                                </Link>
                            </td>
                            <td v-else>
                                {{ __('tools.partners.contracts.table.no-customer') }}
                            </td>
                        </template>
                        <template #contract_id="{item}">
                            <td v-if="item.contract_id || item.customer_number">
                                <Link
                                    :href="contractUrl(item.customer_number, item.contract_id)"
                                >
                                    {{ item.contract_id }}
                                </Link>
                            </td>
                            <td v-else>
                                {{ __('tools.partners.contracts.table.no-contract') }}
                            </td>
                        </template>
                    </DTable>
                    <DPagination
                        v-if="contracts.last_page > 1"
                        :active-page="contracts.current_page"
                        :pages="contracts.last_page"
                        align="center"
                        @update:activePage="changePage"
                    />
                </DCol>
            </DRow>
        </DCard>
    </div>
</template>

<script>

export default {
    name: 'ContractsIndex',
    components: { },
    props: {
        contracts: {
            type: Object,
            default: () => { return {} }
        },
        errors: {
            type: Object,
            default: () => { return {} }
        }
    },
    data () {
        return {
            fields: [
                { key: 'customer_number', label: this.__('tools.partners.contracts.table.customer_number') },
                { key: 'company', label: this.__('tools.partners.contracts.table.company_name') },
                { key: 'firstname', label: this.__('tools.partners.contracts.table.firstname') },
                { key: 'lastname', label: this.__('tools.partners.contracts.table.lastname') },
                { key: 'contract_id', label: this.__('tools.partners.contracts.table.contract_id') },
                { key: 'distributor_id', label: this.__('tools.partners.contracts.table.distributor_id') },
                { key: 'credit_note', label: this.__('tools.partners.contracts.table.credit_note') }
            ]
        }
    },
    methods: {
        changePage (page) {
            const queryParameters = {}

            if (page > 1) {
                queryParameters.page = page
            }

            this.$inertia.get(this.$route('tools.partners.contracts.index'), queryParameters)
        },
        customerUrl (customerId) {
            return this.$route('customers.customers.show', {
                customer: customerId
            })
        },
        contractUrl (customerId, contractId) {
            return this.$route('customers.customers.contracts.show', {
                customer: customerId,
                contract: contractId
            })
        }
    }
}
</script>

<style scoped>

</style>
